import { Component, OnInit } from '@angular/core';
import { CONTACTO } from '../../interfaces/contacto.interface';
import { ContactoService } from '../../services/contacto.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';

import { contactoJson } from './contacto.json';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit {

  contactoData: any;
  isDataLoaded: boolean = false;

  mapURI: SafeResourceUrl | undefined;


  constructor(
    private sanitizer: DomSanitizer,
    private contactoService: ContactoService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false; // Can reload the page
    this.route.params.subscribe(params => { });

    this.contactoService.getContacto().subscribe({
      next: (resp: any) => {
        this.contactoData = resp.data;
        this.mapURI = this.safeURL(this.contactoData.locationMapIframe)
        this.isDataLoaded = true;
      },
      error: (error: any) => {
        console.log(error)
      }
    })

  }

  public safeURL(value: any): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  ngOnInit(): void {


  }

}
